import script from "./TournamentHistoryView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TournamentHistoryView.vue?vue&type=script&setup=true&lang=ts"

import "./TournamentHistoryView.vue?vue&type=style&index=0&id=8c80613e&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c80613e"]])

export default __exports__